// Support links model (GUARD-WEB-SUPPORT-POLISH). Public copy only: the three canonical
// public pages plus a version-tagged support mailto so a guard's help email arrives
// pre-triaged. No inbox logic, no routing evidence here - Codex owns that proof pack.

export const SUPPORT_LINKS: ReadonlyArray<{ href: string; label: string }> = [
  { href: "https://thesecops.app/support", label: "Support" },
  { href: "https://thesecops.app/privacy", label: "Privacy" },
  { href: "https://thesecops.app/terms", label: "Terms" },
];

export const SUPPORT_EMAIL = "support@thesecops.app";

export function buildSupportMailto(appVersion: string): string {
  const version = appVersion.trim().length > 0 ? `v${appVersion.trim()}` : "version unknown";
  const subject = encodeURIComponent(`SecOps Guard Web help (${version})`);
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}`;
}
